import { render } from "./Period.vue?vue&type=template&id=066f4c30"
import script from "./Period.vue?vue&type=script&lang=js"
export * from "./Period.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Transcend INNCOM/INNCOM Project/2103.musoon.mobile.vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__